import React, { PropTypes } from 'react';
import Stepper from '../stepper/Stepper';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddNewDistrict.scss';

const stepsDescription = [
  'krok 1 opis sd',
  'krok 2 opis 47',
  'krok 3 opis sdf',
  'krok 4 opis HK',
  'krok 5 opis QE',
  'krok 6 opis ERT',
];

class AddNewDistrict extends React.Component {
  constructor() {
    super();
    this.state = {
      activeStep: 1,
      next: 'disabled',
    };
  }

  changeActiveStep = nr => {
    this.setState({
      activeStep: nr,
    });
  }

  render() {
    return (
      <div className='add-container'>
        <div className='title'>
          Dodawanie gmin do baz danych
        </div>
        <Stepper
          stepsNum={6}
          activeStep={this.changeActiveStep}
          stepsDescription={stepsDescription}
          clickNext={this.state.next}
        />
      </div>
    );
  }
}

export default withStyles(s)(AddNewDistrict);



// WEBPACK FOOTER //
// src/routes/administrator/components/add-new-district/AddNewDistrict.js